import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import enCommon from './locales/en/common.json';
import esCommon from './locales/es/common.json';
import frCommon from './locales/fr/common.json';
import deCommon from './locales/de/common.json';
import enHelp from './locales/en/help.json';
import deHelp from './locales/de/help.json';

// Create a placeholder for Italian translations
const itCommon = { ...enCommon };

const resources = {
  en: {
    common: enCommon,
    help: enHelp
  },
  es: {
    common: esCommon
  },
  fr: {
    common: frCommon
  },
  de: {
    common: deCommon,
    help: deHelp
  },
  it: {
    common: itCommon
  },
  gb: {
    common: enCommon,
    help: enHelp
  }
};

// Languages the site actually offers — keep in sync with the list in
// components/navbar/LanguageSelector.tsx. The fr/it locales are incomplete and not
// selectable, so they must not be picked up from the browser or a stale saved value
// either: that left pages without the navbar in a different language than the rest.
const SUPPORTED_LANGUAGES = ['en', 'de', 'es'];
const DEFAULT_LANGUAGE = 'de';

// Saved choice first, then the browser language, then the default
function getInitialLanguage(): string {
  const saved = localStorage.getItem('language');
  if (saved && SUPPORTED_LANGUAGES.includes(saved)) return saved;
  const browser = navigator.language?.split('-')[0];
  return SUPPORTED_LANGUAGES.includes(browser) ? browser : DEFAULT_LANGUAGE;
}

// Keep <html lang> in step with the active language ('gb' is an alias of English)
i18n.on('languageChanged', lng => {
  const base = lng.split('-')[0];
  document.documentElement.lang = base === 'gb' ? 'en' : base;
});

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: DEFAULT_LANGUAGE,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['navigator', 'localStorage'],
      caches: ['localStorage']
    }
  });

export default i18n;